var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _vm.currentStep === 'check' ? [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.getConfirmTitle))]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v("請輸入業務資訊")]), _c('div', {
    staticClass: "form"
  }, _vm._l(_vm.bindFields, function (field, key) {
    return _c('div', {
      key: key,
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field__label"
    }, [_vm._v(_vm._s(field.display_name))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.bindFieldsInput[field.field_key],
        expression: "bindFieldsInput[field.field_key]"
      }],
      staticClass: "field__input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm.bindFieldsInput[field.field_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.bindFieldsInput, field.field_key, $event.target.value);
        }
      }
    })]);
  }), 0)]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.checkCancel
    }
  }, [_vm._v("取消")]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.checkSubmit
    }
  }, [_vm._v("送出")])], 1)] : _vm._e(), _vm.currentStep === 'confirm' ? [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.getConfirmTitle))]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" 將 "), _c('span', {
    staticClass: "text-primary px-2"
  }, [_vm._v(_vm._s(_vm.staff.name))]), _vm._v(" 設定為您的業務？ ")]), _c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.getAvatar,
      "img-alt": "Image",
      "img-top": ""
    }
  }, _vm._l(_vm.staffProfileDisplay, function (profile, key) {
    return _c('div', {
      key: key,
      attrs: {
        "alt": profile.display_name
      }
    }, [profile.style === 'badge' ? _c('button', {
      staticClass: "btn btn-xs btn-outline-primary",
      attrs: {
        "type": "button"
      }
    }, [_vm._v(" " + _vm._s(_vm.staff[profile.key]) + " ")]) : _c('p', {
      staticClass: "mb-2",
      class: _vm.profileClass(profile.style)
    }, [_vm._v(" " + _vm._s(_vm.staff[profile.key]) + " ")])]);
  }), 0)], 1), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.confirmCancel
    }
  }, [_vm._v("否")]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": _vm.buttonLoading || _vm.disabledAcceptButton
    },
    on: {
      "click": _vm.accept
    }
  }, [_vm._v("是")])], 1)] : _vm._e(), _vm.currentStep === 'result' ? [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.getConfirmTitle))]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getResultSuccessMessage) + " ")]), _c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.getAvatar,
      "img-alt": "Image",
      "img-top": ""
    }
  }, _vm._l(_vm.staffProfileDisplay, function (profile, key) {
    return _c('div', {
      key: key,
      attrs: {
        "alt": profile.display_name
      }
    }, [profile.style === 'badge' ? _c('button', {
      staticClass: "btn btn-xs btn-outline-primary",
      attrs: {
        "type": "button"
      }
    }, [_vm._v(" " + _vm._s(_vm.staff[profile.key]) + " ")]) : _c('p', {
      staticClass: "mb-2",
      class: _vm.profileClass(profile.style)
    }, [_vm._v(" " + _vm._s(_vm.staff[profile.key]) + " ")])]);
  }), 0)], 1), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(_vm._s(_vm.getExitActionText))])], 1)] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }